/** Shared frame of the mobile filter and search panels. */
const DRAWER_FRAME_CLASS_NAME =
  'rounded-t-gl-border-radius-xg border-t border-gl-color-shades-gray-20'

/** The panels that hold a list take the full drawer height. */
const DRAWER_CLASS_NAME = `h-[90vh] ${DRAWER_FRAME_CLASS_NAME}`

export { DRAWER_CLASS_NAME, DRAWER_FRAME_CLASS_NAME }
